import {
    LOGINLOADING,
    LOGINSUCCESS,
    LOGINERROR,
    SIGNOUTSUCCESS,
    PROFILEUPDATESUCCESS,
    PROFILEUPDATERESET,
    PROFILEUPDATEFAILED,
    USERDATAUPDATE

} from "../actionTypes";
const init_state = {
    updated: false,
    user: null,
    loading: false,
    error: false,
    errorMessage: null,
    updatefailed: false,
    updatefailedmessage: null,
}
export const userReducer = (state = init_state, {
    type,
    payload
}) => {
    switch (type) {

        case LOGINSUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                user: payload
            }
            case USERDATAUPDATE:
            return {
                ...state,
                user: payload
            }
            case PROFILEUPDATESUCCESS:
                return {
                    ...state,
                    user: payload,
                    updated: true
                }
                case PROFILEUPDATERESET:
                    return {
                        ...state,
                        updated: false, 
                        updatefailed: false,
                        updatefailedmessage: null,
                    }
                    case  PROFILEUPDATEFAILED:
                        return {
                            ...state,
                            updated: false,
                            updatefailed: true,
                         updatefailedmessage: payload,
                            
                        }
                        
            case LOGINERROR:
                return {
                    ...state,
                    user: null,
                        loading: false,
                        error: true,
                        errorMessage: payload
                }
                case LOGINLOADING:
                    return {
                        ...state,
                        user: null,
                            loading: true,
                            error: false,
                            errorMessage: ""
                    }
                    case SIGNOUTSUCCESS:
                        return {
                            ...state,
                            user: null,
                                loading: false,
                                error: false,
                                errorMessage: ""
                        }
                        default:
                            return state
    }
}